import { Container, Texture } from '../../../odie';

import { ChameleonBlockProps, ColorId } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-----------------------------------------------------------------------------
export type ChameleonColor = Exclude<ColorId, 'all'>;
export const chameleonColors: { color: ChameleonColor; asset: string }[] = [
  { color: 'blue', asset: 'chamaleon/block.chameleon.blue.png' },
  { color: 'red', asset: 'chamaleon/block.chameleon.red.png' },
  { color: 'yellow', asset: 'chamaleon/block.chameleon.yellow.png' },
  { color: 'green', asset: 'chamaleon/block.chameleon.green.png' },
  { color: 'purple', asset: 'chamaleon/block.chameleon.purple.png' },
];

/*
    chameleon block view
*/
export class ChameleonBlockView extends Container {
  // fields
  //-------------------------------------------------------------------------
  private _sprite: FitWidthBlockSprite;
  private _color: ChameleonColor = 'blue';

  // properties
  //-------------------------------------------------------------------------
  public get color(): ChameleonColor {
    return this._color;
  }

  public set color(value: ChameleonColor) {
    if (this._color === value) return;
    // update field
    this._color = value;

    // update view texture based on count
    const asset = chameleonColors.find((data) => data.color === value)!.asset;
    this._sprite.texture = Texture.from(asset);
  }

  // init
  //-------------------------------------------------------------------------
  constructor(props: ChameleonBlockProps) {
    // create base view
    super();
    this._sprite = new FitWidthBlockSprite(chameleonColors[0].asset, props);
    this.addChild(this._sprite);

    // position
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return chameleonColors.map((entry) => entry.asset);
  }
}
